import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import FunctionBoxAverage from './FunctionBoxAverage';
import FunctionBoxCount from './FunctionBoxCount';
import FunctionBoxVolume from './FunctionBoxVolume';
import FunctionBoxNTitle from './FunctionBoxNTitle';
import FunctionBoxPublications from './FunctionBoxPublications';
import DynamicTabs from '../../common/DynamicTabs';
import GenericButton from '../../common/GenericButton';
import Modal from '../../common/Modal/Modal';
import AddToDefinition from '../../common/AddToDefinition';
import TitleValidationModal from './TitleValidationModal';

import * as crosstabActions from '../../../actions/crosstabActions';
import { buildDictionaryItem } from '../../autocode/AutocodeFunctions';
import { getDicForDefKeywords } from '../../../actions/autocodeActions';
import { buildFunctionNode } from '../../../util/autocodeUtils';

const modalStyle = {
  width: '50%',
  height: '300px',
  left: '40%',
};

const TitleValidationModalStyle = {
  width: '30%',
  height: 'auto',
  left: '45%',
  top: '25%',
};

class FunctionBox extends Component {
  constructor(props) {
    super(props);
    this.getFunctionBoxSampleWeighted();
    this.state = {
      functionTitle: '',
      moveToCustomMessage: '',
    };
  }

  componentWillUnmount() {
    this.props.crosstabActions.clearSampleWeighted('FunctionBoxCommonDataGrid');
    this.props.crosstabActions.clearSampleWeighted('FunctionBoxCountDataGrid');
  }

  getFunctionBoxSampleWeighted = () => {
    const selectedKeywords = [];
    const countRangeKeywords = [];
    const selectedNames = [];

    const keywordsString = this.props.selectedTargets.reduce(
      (acc, item) => `${acc}${item.keyword}, `,
      ''
    );

    this.props.selectedTargets.map((item, index, arr) => {
      selectedKeywords.push(item.keyword);
      selectedNames.push(item.shortText);
      countRangeKeywords.push(
        `COUNTRANGE(${keywordsString} ${index}, ${index} )`
      );
      if (index + 1 === arr.length) {
        countRangeKeywords.push(
          `COUNTRANGE(${keywordsString} ${index + 1}, ${index + 1} )`
        );
      }
      return null;
    });
    const sampleWeightedParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.crosstabStudy.pn,
      weightType: this.props.crosstabWeightTypes.wt,
      divisor: this.props.crosstabWeightTypes.dv,
      isLabelUpdated: [false],
      selectedNames,
    };

    this.props.crosstabActions.getSampleWeighted({
      ...sampleWeightedParams,
      targetGrid: 'FunctionBoxCommonDataGrid',
      expressionList: selectedKeywords,
    });

    this.props.crosstabActions.getSampleWeighted({
      ...sampleWeightedParams,
      targetGrid: 'FunctionBoxCountDataGrid',
      expressionList: countRangeKeywords,
    });
  };

  handleTitleText = event =>
    this.setState({ functionTitle: event.target.value });

  moveAppendToCodingBox = (isMove, expressionKeyword, smartSearchArray) =>
    this.props.moveAppendToCodingBox(
      isMove,
      expressionKeyword,
      this.state.functionTitle,
      smartSearchArray
    );

  handleSmartSearchArray = objSmartSearchArray => {
    const newObjectSmartSearchArr = _.cloneDeep(objSmartSearchArray);
    return newObjectSmartSearchArr;
  };

  moveToRows = (expressionKeyword, objSmartSearchArray) => {
    if (this.state.functionTitle) {
      if (expressionKeyword) {
        const sampleWeightedParams = {
          targetGrid: 'RowsDataGrid',
          sourceGrid: 'FunctionBox',
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.crosstabStudy.pn,
          weightType: this.props.crosstabWeightTypes.wt,
          divisor: this.props.crosstabWeightTypes.dv,
          expressionList: [expressionKeyword],
          gridData: this.props.crosstabRows,
          selectedNames: [this.state.functionTitle],
          isLabelUpdated: [true],
          objSmartSearchArray: [
            this.handleSmartSearchArray(objSmartSearchArray),
          ],
        };
        if (sampleWeightedParams.objSmartSearchArray[0].autocodenode) {
          this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
        } else {
          getDicForDefKeywords(
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
            this.props.crosstabStudy.pn,
            objSmartSearchArray.expressionFormed
          ).then(response => {
            const dictionaryData = [
              ...objSmartSearchArray.expressionFormed.map(item =>
                buildDictionaryItem(item, response[item])
              ),
            ];
            sampleWeightedParams.objSmartSearchArray[0].autocodenode = buildFunctionNode(
              response,
              expressionKeyword,
              objSmartSearchArray.expressionFormed,
              dictionaryData,
              sampleWeightedParams.isLabelUpdated,
              this.state.functionTitle,
              true
            );
            this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
          });
        }

        // this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      }
    } else {
      this.setState({
        moveToCustomMessage:
          'You must enter a title to add an expression to rows',
      });
      this.titleValidationModal.show();
    }
  };

  moveToColumns = (expressionKeyword, objSmartSearchArray) => {
    if (this.state.functionTitle) {
      if (expressionKeyword) {
        const sampleWeightedParams = {
          targetGrid: 'ColumnsDataGrid',
          sourceGrid: 'FunctionBox',
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.crosstabStudy.pn,
          weightType: this.props.crosstabWeightTypes.wt,
          divisor: this.props.crosstabWeightTypes.dv,
          expressionList: [expressionKeyword],
          gridData: this.props.crosstabColumns,
          selectedNames: [this.state.functionTitle],
          isLabelUpdated: [true],
          objSmartSearchArray: [
            this.handleSmartSearchArray(objSmartSearchArray),
          ],
        };
        if (sampleWeightedParams.objSmartSearchArray[0].autocodenode) {
          this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
        } else {
          getDicForDefKeywords(
            this.props.loginResponse.data.uid,
            this.props.activeAccountId,
            this.props.crosstabStudy.pn,
            objSmartSearchArray.expressionFormed
          ).then(response => {
            const dictionaryData = [
              ...objSmartSearchArray.expressionFormed.map(item =>
                buildDictionaryItem(item, response[item])
              ),
            ];
            sampleWeightedParams.objSmartSearchArray[0].autocodenode = buildFunctionNode(
              response,
              expressionKeyword,
              objSmartSearchArray.expressionFormed,
              dictionaryData,
              sampleWeightedParams.isLabelUpdated,
              this.state.functionTitle,
              true
            );
            this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
          });
        }

        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      }
    } else {
      this.setState({
        moveToCustomMessage:
          'You must enter a title to add an expression to columns',
      });
      this.titleValidationModal.show();
    }
  };

  addToDefinition = expressionKeyword => {
    if (this.state.functionTitle) {
      this.setState({
        addToDefinition: [
          {
            id: 0,
            name: this.state.functionTitle,
            expression: expressionKeyword,
          },
        ],
      });
      this.addToDefinitionModal.show();
    } else {
      this.setState({
        moveToCustomMessage:
          'You must enter a title to save this expression to definitions',
      });
      this.titleValidationModal.show();
    }
  };

  // for not letting breadcrumb to be removed
  handleSelect = (index, last) => {
    console.warn(`Selected tab: ${index}, Last tab: ${last}`);
  };

  render() {
    return (
      <div className="function-box">
        <div className="row">
          <div className="small-1 medium-1 large-1 columns">
            <h5 className="middle margin-top-5">Title</h5>
          </div>
          <div className="small-11 medium-11 large-11 columns">
            <input
              type="text"
              id="Name"
              placeholder="Type a Name Here..."
              onChange={this.handleTitleText}
            />
          </div>
          <div className="small-12 columns">
            <DynamicTabs
              tabs={[
                {
                  title: 'Average',
                  content: (
                    <FunctionBoxAverage
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                    />
                  ),
                },
                {
                  title: 'Count',
                  content: (
                    <FunctionBoxCount
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                    />
                  ),
                },
                {
                  title: 'Volume',
                  content: (
                    <FunctionBoxVolume
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                    />
                  ),
                },
                {
                  title: 'N-Tile',
                  content: (
                    <FunctionBoxNTitle
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                    />
                  ),
                },
                {
                  title: 'Publications',
                  content: (
                    <FunctionBoxPublications
                      selectedTargets={this.props.selectedTargets}
                      functionTitle={this.state.functionTitle}
                      moveAppendToCodingBox={this.moveAppendToCodingBox}
                      moveToRows={this.moveToRows}
                      moveToColumns={this.moveToColumns}
                      addToDefinition={this.addToDefinition}
                      sampleWeightedValues={this.props.sampleWeightedValues}
                      crosstabActions={this.props.crosstabActions}
                      probabilityFunctionList={
                        this.props.probabilityFunctionList
                      }
                    />
                  ),
                },
              ]}
              moduleStudy={this.props.crosstabStudy}
              activeScreen="functionBox"
              handleSelect={this.handleSelect}
            />
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns">
            <div className="modal-footer">
              <div className="float-right">
                <GenericButton
                  name="Close"
                  onBtnClick={() => this.props.handleParentHide()}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Title Required"
          ref={node => (this.titleValidationModal = node)}
          dialogStyles={TitleValidationModalStyle}
        >
          <div className="row">
            <TitleValidationModal
              customMessage={this.state.moveToCustomMessage}
              handleParentHide={() => this.titleValidationModal.hide()}
            />
          </div>
        </Modal>
        <Modal
          title="Add to Definition..."
          ref={node => (this.addToDefinitionModal = node)}
          dialogStyles={modalStyle}
        >
          <AddToDefinition
            folderName={this.state.functionTitle}
            newExpressions={this.state.addToDefinition}
            handleHide={() => this.addToDefinitionModal.hide()}
            srcScreen="QuestionsScreen"
            moduleStudy={this.props.crosstabStudy}
          />
        </Modal>
      </div>
    );
  }
}
FunctionBox.propTypes = {
  handleParentHide: PropTypes.func,
  moveAppendToCodingBox: PropTypes.func,
  selectedTargets: PropTypes.arrayOf(PropTypes.object).isRequired,
  crosstabColumns: PropTypes.arrayOf(PropTypes.object),
  crosstabRows: PropTypes.arrayOf(PropTypes.object),
  sampleWeightedValues: PropTypes.arrayOf(PropTypes.object),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
  }),
  crosstabActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
  }),
  activeAccountId: PropTypes.number,
  crosstabWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
};
function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    crosstabStudy: state.study.crosstabStudy,
    crosstabColumns: state.crosstab.ColumnsDataGridData,
    crosstabRows: state.crosstab.RowsDataGridData,
    crosstabWeightTypes: state.study.crosstabWeightTypes,
    sampleWeightedValues: state.crosstab.FunctionBoxCommonDataGridData,
    probabilityFunctionList: state.crosstab.probabilityFunctionList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FunctionBox);
